export default "__VITE_ASSET__Cx4R3L6V__"